// בורר המתנה בעגלה · עונת החגים
// יושב מחוץ לאזורים שהערכה מרעננת, כדי שירוץ גם כשהמגירה נטענת מחדש.
(function () {
  if (window.__pgiftReady) return;
  window.__pgiftReady = true;

  var GIFTS = [48277809955046, 48277810053350, 48277810086118, 48277810184422, 48277810217190, 48277810249958];

  // מרעננים דרך הערכה — כך המגירה נשארת פתוחה והכתובת לא משתנה
  function refreshCart() {
    var cf = document.querySelector('cart-form');
    if (cf && typeof cf.refresh === 'function') { cf.refresh(); return true; }
    return false;
  }

  // ── בחירת מתנה ──
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pgift-pick]');
    if (!b || b.disabled) return;
    e.preventDefault();

    var item = b.closest('.pgift-item');
    var sel  = item ? item.querySelector('.pgift-variant') : null;
    var id   = b.getAttribute('data-variant') || (sel && sel.value);
    if (!id) return;

    // כבר נבחרה, ובאותו דגם — אין מה לעשות
    if (item && item.classList.contains('is-chosen') &&
        (!sel || String(sel.value) === String(id))) return;

    b.disabled = true;
    b.textContent = 'רגע…';

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // מסירים כל מתנה קיימת — תמיד אחת בלבד
        var drop = cart.items.filter(function (i) { return GIFTS.indexOf(i.variant_id) > -1; });
        var chain = Promise.resolve();
        drop.forEach(function (i) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: String(i.key), quantity: 0 })
            });
          });
        });
        return chain;
      })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1,
                                properties: { _pgift: '1' } }] })
        });
      })
      .then(function () {
        if (!refreshCart()) { window.location.reload(); return; }
        // רשת ביטחון אם הרענון לא החזיר תוכן חדש
        setTimeout(function () {
          var stuck = document.querySelector('[data-pgift-pick][disabled]');
          if (stuck) { stuck.disabled = false; stuck.textContent = 'זו המתנה שלי'; }
        }, 2500);
      })
      .catch(function () {
        b.disabled = false;
        b.textContent = 'זו המתנה שלי';
      });
  });


  // ── שומר הסף ──
  // המתנה היא מוצר במחיר 0, לא הנחה, ולכן שופיפיי לא מסירה אותה לבד
  // כשהסל יורד מתחת לסף. הבדיקה רצה אחרי כל שינוי בעגלה.
  var THRESHOLD = 40000;          // 400 ₪ באגורות
  var busy = false;

  function basketWithoutGift(cart) {
    var sum = 0;
    cart.items.forEach(function (i) {
      if (GIFTS.indexOf(i.variant_id) === -1) sum += i.original_line_price;
    });
    return sum;
  }

  function dropLines(lines) {
    var chain = Promise.resolve();
    lines.forEach(function (l) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(l.key), quantity: 0 })
        });
      });
    });
    return chain;
  }

  function enforce() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gifts = cart.items.filter(function (i) { return GIFTS.indexOf(i.variant_id) > -1; });
        if (!gifts.length) { busy = false; return; }

        // המבצע נסגר — כל המתנות יורדות. השרת הוא שקובע, לא שעון הדפדפן.
        var gate = document.querySelector('[data-pgift-window]');
        if (gate && gate.getAttribute('data-pgift-window') === 'false') {
          return dropLines(gifts).then(function () {
            busy = false;
            if (!refreshCart()) window.location.reload();
          });
        }

        // מתחת לסף — המתנה יורדת
        if (basketWithoutGift(cart) < THRESHOLD) {
          return dropLines(gifts).then(function () {
            busy = false;
            if (!refreshCart()) window.location.reload();
          });
        }
        // יותר ממתנה אחת, או כמות גדולה מ-1 — משאירים אחת
        var extra = gifts.slice(1);
        var over  = gifts[0].quantity > 1 ? gifts[0] : null;
        if (!extra.length && !over) { busy = false; return; }
        return dropLines(extra)
          .then(function () {
            if (!over) return;
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: String(gifts[0].key), quantity: 1 })
            });
          })
          .then(function () {
            busy = false;
            if (!refreshCart()) window.location.reload();
          });
      })
      .catch(function () { busy = false; });
  }

  // כל שינוי בעגלה — מאיפה שלא יגיע — מפעיל בדיקה
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url) && !busy) {
      p.then(function () { setTimeout(enforce, 350); }).catch(function () {});
    }
    return p;
  };
  document.addEventListener('DOMContentLoaded', function () { setTimeout(enforce, 600); });
  if (document.readyState !== 'loading') setTimeout(enforce, 600);

  // ── פתיחה וסגירה ──
  // המצב יושב על תגית <html> ולא בתוך הבלוק, כי הערכה
  // מרעננת את אזור הסל ומוחקת כל מה שבתוכו.
  // בכוונה לא נשמר בין עמודים: מי שסגרה פעם אחת לא נשארת בלי המתנה.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-pgift-toggle]')) return;
    e.preventDefault();
    document.documentElement.classList.toggle('pgift-flip');
  });

  // ניקוי שאריות מגרסאות קודמות
  try { sessionStorage.removeItem('pgiftHidden'); } catch (err) {}
  document.documentElement.classList.remove('pgift-off');
})();
